var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAverageProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8053 0.38711C21.2073 0.400161 21.5227 0.736672 21.5096 1.13873C21.2344 9.61874 14.1382 16.2632 5.65885 15.988C5.25679 15.9749 4.94144 15.6384 4.95449 15.2364C4.96754 14.8343 5.30406 14.519 5.70611 14.532C13.382 14.7812 19.8045 8.76672 20.0537 1.09147C20.0667 0.689409 20.4032 0.374058 20.8053 0.38711Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3235 0.160938C20.6369 -0.0912543 21.0954 -0.0416369 21.3476 0.271762L23.8386 3.36734C24.0908 3.68074 24.0412 4.13924 23.7278 4.39143C23.4144 4.64362 22.9559 4.59401 22.7037 4.28061L20.2127 1.18503C19.9605 0.871633 20.0101 0.413131 20.3235 0.160938Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.343 0.269912C21.5962 0.582487 21.5481 1.04115 21.2355 1.29436L18.2054 3.74897C17.8929 4.00218 17.4342 3.95406 17.181 3.64148C16.9278 3.32891 16.9759 2.87025 17.2885 2.61704L20.3185 0.162429C20.6311 -0.0907843 21.0898 -0.0426623 21.343 0.269912Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49355 22.3264C2.76883 13.8463 9.86496 7.20175 18.3443 7.477C18.7464 7.49005 19.0617 7.82656 19.0487 8.22862C19.0356 8.63068 18.6991 8.94603 18.2971 8.93298C10.6212 8.6838 4.19868 14.6984 3.94953 22.3736C3.93648 22.7757 3.59997 23.091 3.19791 23.078C2.79585 23.0649 2.4805 22.7284 2.49355 22.3264Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.271762 19.0711C0.58516 18.8189 1.04366 18.8685 1.29585 19.1819L3.78687 22.2775C4.03906 22.5909 3.98945 23.0494 3.67605 23.3016C3.36265 23.5538 2.90415 23.5042 2.65195 23.1908L0.160938 20.0952C-0.0912543 19.7818 -0.0416369 19.3233 0.271762 19.0711Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81757 19.8168C7.07079 20.1294 7.02266 20.588 6.71009 20.8412L3.68004 23.2958C3.36747 23.5491 2.90881 23.5009 2.65559 23.1884C2.40238 22.8758 2.4505 22.4171 2.76308 22.1639L5.79312 19.7093C6.1057 19.4561 6.56436 19.5042 6.81757 19.8168Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageProfit);
export default __webpack_public_path__ + "static/media/average-profit.87efa7fbc2d2f838a33d13c91b0cb140.svg";
export { ForwardRef as ReactComponent };